export const AUTH0_STORE = '@Auth0_Store';
export const LOGIN = '@Auth0_Login';
export const LOGIN_USERNAME_PASSWORD = '@Auth0_Login_username_password';
export const SOCIAL_CONNECTION = '@Auth0_Social_connection';
export const ERROR_LOGIN = '@Auth0_Login_Error';

export const LOGGED = '@Auth0_Logged';
export const ALREADY_LOGGED_IN = '@Auth0_Already_logged_in';

export const LOGOUT = '@Auth0_Logout';
export const ERROR_LOGOUT = '@Auth0_Logout_Error';

export const SIGNUP = '@Auth0_Signup';
export const SIGNUP_DATA = '@Auth0_Signup_Data';
export const ERROR_SIGNUP = '@Auth0_Signup_Error';

export const RECOVER_PASSWORD = '@Auth0_Recover_Password';
export const RECOVER_PASSWORD_ERROR = '@Auth0_Recover_Password_Error';

export default {
    LOGIN,
    LOGIN_USERNAME_PASSWORD,
    LOGGED,
    ALREADY_LOGGED_IN,
    ERROR_LOGIN,
    LOGOUT,
    ERROR_LOGOUT,
    SIGNUP,
    SIGNUP_DATA,
    ERROR_SIGNUP,
    SOCIAL_CONNECTION,
    RECOVER_PASSWORD
};
